import React from 'react';
import PropTypes from 'prop-types';
import Row from '../../../shared/components/Row';
import Card from '../../../shared/components/Card';
import CardHeader from '../../../shared/components/card-header/CardHeader';
import CardBody from '../../../shared/components/CardBody';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import { WorkDetailRequest } from './work-detail/WorkDetailRequest';
import { WorkDetailTask } from './work-detail/WorkDetailTask';
import Alert from 'react-s-alert';
import { PsWork } from '../../../shared/work/PsWork';
import HeaderSearchRefreshFilterOptions from '../../../shared/components/HeaderSearchRefreshFilterOptions';
import { WorkDetailForm } from './WorkDetailForm';
import { WorkDetailFormValues } from './WorkDetailFormValues';

export class WorkDetailCard extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            contracts: [],
            initialValues: null,
        };
    }

    componentDidMount() {
        this.getWork();
    }

    render() {
        const { loading } = this.props;
        const { contracts, initialValues } = this.state;

        return (
            <Row clearfix>
                <Card loading={loading}>
                    <CardHeader
                        title={I18nUtils.tr('TR_FICHA_OBRA').toUpperCase()}
                        rightOptions={(
                            <HeaderSearchRefreshFilterOptions
                                enableRefresh={true}
                                onRefresh={this.getWork}
                                enableFilter={false}
                                enableSearch={false}
                            />
                        )}
                    />
                    <CardBody className={'table-responsive'}>
                        {
                            initialValues ? (
                                <WorkDetailForm
                                    initialValues={initialValues}
                                    contracts={contracts}
                                />
                            ) : null
                        }
                    </CardBody>
                </Card>
            </Row>
        );
    }

    getWork = () => {
        const { id, appendBreadcrumb } = this.props;
        const request = new WorkDetailRequest();

        request.setId(id);

        new WorkDetailTask(request)
            .onPreExecution(() => this.setState({ loading: true }))
            .onSuccess((res) => {
                const work = PsWork.fromAPIConstructionSite(res.data);
                const contracts = work.contracts();
                const formValues = WorkDetailFormValues.fromWork(work);
                const initialValues = formValues.initialValues();
                appendBreadcrumb(work);
                this.setState({ contracts, initialValues });
            })
            .onFail((error) => Alert.error(error))
            .onPostExecution(() => this.setState({ loading: false }))
            .execute();
    };
}

WorkDetailCard.propTypes = {
    id: PropTypes.string.isRequired,
    appendBreadcrumb: PropTypes.func,
};

WorkDetailCard.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-contractors/work/detail/WorkDetailCard.jsx